import React, { useState } from 'react';
import { Button, Collapse, Icon } from '@podiumhq/design-system';

import { buttonGhostLinkStyles } from 'styles';

import BundleList from './BundleList';
import { PACKAGE_PRICES_MONTHLY, PACKAGE_PRICES_YEARLY } from '../constants';

const toggleLinkDefaultProps = {
  ...buttonGhostLinkStyles,
  color: 'blue.base',
  display: 'block',
  fontSize: 20,
  lineHeight: '150%',
  margin: '0 auto',
  size: 'md',
};

const BundleListCollapsable = ({
  buttonLabel = 'Compare plans and features',
  canChoosePlan,
  currentBundle,
  displayPrice,
  handleCtaOnClick,
  monthlyPackagePrices = PACKAGE_PRICES_MONTHLY,
  onToggleFeatureList,
  priceTerm,
  toggleLinkProps = toggleLinkDefaultProps,
  yearlyPackagePrices = PACKAGE_PRICES_YEARLY,
  ...collapseWrapperProps
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleBundleList = () => {
    setIsOpen(!isOpen);
    onToggleFeatureList && onToggleFeatureList();
  };

  return (
    <>
      <Button onClick={toggleBundleList} {...toggleLinkProps}>
        {`${buttonLabel} `}
        <Icon type={isOpen ? 'AngleUp' : 'AngleDown'} color="blue.base" />
      </Button>

      <Collapse
        animateOpacity
        endingHeight="auto"
        in={isOpen}
        startingHeight={0}
        style={isOpen ? { overflow: 'unset' } : {}}
        {...collapseWrapperProps}
      >
        <BundleList
          canChoosePlan={canChoosePlan}
          currentBundle={currentBundle}
          displayPrice={displayPrice}
          handleCtaOnClick={handleCtaOnClick}
          monthlyPackagePrices={monthlyPackagePrices}
          onToggleFeatureList={onToggleFeatureList}
          priceTerm={priceTerm}
          yearlyPackagePrices={yearlyPackagePrices}
        />
      </Collapse>
    </>
  );
};

export default BundleListCollapsable;
